var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDriveSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_2893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.53846 25.7115L4.01923 28.2692C4.32692 28.8077 4.76923 29.2308 5.28846 29.5385L10.5769 20.3846H0C0 20.9808 0.153846 21.5769 0.461538 22.1154L2.53846 25.7115Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7885 9.61538L11.5 0.461533C10.9808 0.769225 10.5385 1.1923 10.2308 1.73076L0.461538 18.6538C0.159505 19.1807 0.00040214 19.7773 0 20.3846H10.5769L16.7885 9.61538Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2883 29.5385C28.8075 29.2308 29.2498 28.8077 29.5575 28.2692L30.1729 27.2115L33.1152 22.1154C33.4229 21.5769 33.5767 20.9808 33.5767 20.3846H22.999L25.2498 24.8077L28.2883 29.5385Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7885 9.61539L22.0769 0.461538C21.5577 0.153846 20.9615 0 20.3462 0H13.2308C12.6154 0 12.0192 0.173077 11.5 0.461538L16.7885 9.61539Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 20.3846H10.577L5.28857 29.5385C5.8078 29.8462 6.40396 30 7.01934 30H26.5578C27.1732 30 27.7693 29.8269 28.2886 29.5385L23.0001 20.3846Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2309 10.1923L23.3463 1.73076C23.0386 1.1923 22.5963 0.769225 22.077 0.461533L16.7886 9.61538L23.0001 20.3846H33.5578C33.5578 19.7885 33.404 19.1923 33.0963 18.6538L28.2309 10.1923Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_2893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.5769,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDriveSvg);
export default __webpack_public_path__ + "static/media/GoogleDriveSvg.a3fb37c2c0bba8e51767e27ef851fed5.svg";
export { ForwardRef as ReactComponent };